import React, { useEffect, useState } from 'react'
import { Col, Row } from "antd"
import { BP, Errors, TrayScanned, WeeklyCount } from "../activityCardsUtils/ActivityCardsUtils"
import { getCountCurrentBP } from '../../api/BPTable/BPTableMethods'
import { getCountTrayError, getCountTray, getCountTrayDate } from '../../api/trayTable/TrayTableMethods'
import moment from "moment"
import "./globalView.css"
import { STATUS } from '../interface/interface'

const GlobalView = () => {
  const [currentLoading, setCurrentLoading] = useState<boolean>(false)
  const [errorLoading, setErrorLoading] = useState<boolean>(false)
  const [countCurrent, setCountCurrent] = useState<any>(0)
  const [errorsCount, setErrorsCount] = useState<{ count: number }>({ count: 0 })
  const [trayCount, setTrayCount] = useState<any>(0)
  const [trayCountLoading, setTrayCountLoading] = useState<boolean>(false)
  const [weekCount, setWeekCount] = useState<any>({ count: 0 })
  const [weekLoading, setWeekLoading] = useState<boolean>(false)

  useEffect(() => {
    getCurrent()
    getErrors()
    getTrayCount()
    getTrayCountByWeek()
  }, [])

  const getErrors = async () => {
    setErrorLoading(true)
    const errorsCount = await getCountTrayError();
    setErrorsCount(errorsCount)
    setErrorLoading(false)
  }

  const getCurrent = async () => {
    setCurrentLoading(true)
    const count = await getCountCurrentBP();
    if (count)
      setCountCurrent(count)
    setCurrentLoading(false)
  }

  const getTrayCount = async () => {
    setTrayCountLoading(true)
    const count = await getCountTray(undefined);
    if (count)
      setTrayCount(count)
    setTrayCountLoading(false)
  }

  const getTrayCountByWeek = async () => {
    setWeekLoading(true)
    const today = new Date();
    const firstDay = new Date(today.setDate(today.getDate() - today.getDay() + 1));
    const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 7));
    firstDay.setHours(0, 0, 1)
    lastDay.setHours(23, 59, 59)
    const count = await getCountTrayDate(firstDay, lastDay, [STATUS.SUCCESS, STATUS.ERROR, STATUS.PENDING])
    if (count) {
      setWeekCount(count)
    }
    setWeekLoading(false)
  }

  return (
    <>
      <h2 className='global-view-title'>Vue d'ensemble du {moment(new Date()).format("dddd D MMMM YYYY")}</h2>
      <Row justify="space-between" >
        <Col className="global-view-card" xs={24} md={11} lg={4}><BP count={countCurrent} loading={currentLoading} /></Col>
        <Col className="global-view-card" xs={24} md={11} lg={4}><Errors count={errorsCount} loading={errorLoading} /></Col>
        <Col className="global-view-card" xs={24} md={11} lg={4}><TrayScanned count={trayCount} loading={trayCountLoading} /></Col>
        <Col className="global-view-card" xs={24} md={11} lg={4}><WeeklyCount count={weekCount} loading={weekLoading} /></Col>
      </Row>
    </>
  )
}

export default GlobalView